import { styled } from '@mui/material'

export const SpaceDivider = styled('div')(() => ({
  height: '20px',
}))
